import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEdit } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import moment from "moment-timezone";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import CreateCampaign from "./CreateCampaign";
import { DataGrid } from "@mui/x-data-grid";
import { Delete } from "@mui/icons-material";
import { formatAmount } from "../../Utility/functions/Helper";
// import CreateCampaign from "./CreateCampaign";
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const Campaign = () => {
  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [createBou, setCreateBon] = useState(false);
  const [images, setImages] = useState("");
  const [editData, setEditData] = useState({});

  let image_baseurl = `${endPoints.apiBaseUrl}`;



  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchBounsData();
  }, []);

  const fetchBounsData = async (data) => {
    let url = `${endPoints.api.GET_ALL_CAMPAIGN}`;
    setIsLoading(true);
    await getAllData(url, data)
      .then((response) => {
        console.log("data", response.status);
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);

          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  const onClose = () => {
    setCreateBon(false);
    fetchBounsData();
  };

  const DeleteCampaign = (id) => {
    setIsLoading(true);
    let url = `${endPoints.api.DELETE_CAMPAIGN}/${id}`;
    deleteData(url)
      .then((response) => {
        setIsLoading(false);

        console.log("res", response);
        if (response.data.status === "success") {
          SuccesToast("Campaign Deleted Successfully.");
          fetchBounsData();
        } else {
          ErrorToast(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
 
  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Campaign
                  </h3>
                  <div>
                  <Button
                    variant="primary"
                    className="mrglft10"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                     navigate('/campaignUser')
                    }}
                  >
                  Campaign Users
                  </Button>
                  <Button
                    variant="primary"
                    className="mrglft10"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      setEditData({});
                      setCreateBon(true);
                    }}
                  >
                    Add Campaign
                  </Button>
                  </div>
                  {/* <Button
                    variant="primary"
                    className="mrglft10"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      setEditData({});
                      setCreateBon(true);
                    }}
                  >
                    Add Campaign
                  </Button> */}
                </div>
              </div>
              <CreateCampaign
                open={createBou}
                onClose={onClose}
                editData={editData}
              />
            

              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Campaign ID</TableCell>
                            <TableCell align="center">Campaign Name</TableCell>
                            <TableCell align="center">Start Date </TableCell>
                            <TableCell align="center">End Date </TableCell>
                            <TableCell align="center">Expiry Date of bonus</TableCell>
                            <TableCell align="center">Max Credit Per Customer</TableCell>
                            <TableCell align="center">Max Bonus amount </TableCell>
                            <TableCell align="center">Promocode</TableCell>
                            {/* <TableCell align="center"> Amount consumed of the bonus</TableCell>
                            <TableCell align="center">Expired amount</TableCell>
                            <TableCell align="center">Associated promocode</TableCell>
                            <TableCell align="center">Person, user or system that issued the bonus</TableCell>
                            <TableCell align="center">Some bonus types will require additional data fields like Coupon.</TableCell> */}
                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? rows.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            : rows
                          ).map((row) => (
                            <TableRow
                              key={row.idUser}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">{row.idCampaign}</TableCell>
                              <TableCell align="center">{row.campaignName}</TableCell>
                              
                              <TableCell align="center">
                              {moment
                                  .utc(row.startTime)
                                  .format("MMMM Do YYYY, h:mm a")}
                              </TableCell>
                              <TableCell align="center">
                                {moment
                                  .utc(row.endTime)
                                  .format("MMMM Do YYYY, h:mm a")}
                              </TableCell>

                              <TableCell align="center">
                        
                               {moment
                                  .utc(row.bonusExpiry)
                                  .format("MMMM Do YYYY, h:mm a")}
                              </TableCell>

                              <TableCell align="center">{row.maxNumber}</TableCell>
                              <TableCell align="center">$ {formatAmount(row.maxCredit)}</TableCell>
                              <TableCell align="center">{row.promoCode}</TableCell>
                             
                            

                           

                              <TableCell align="center">
                  
                                     {
                                  
                                  <div className="row">
                                  <div className="col-5">
                                  <AiOutlineEdit
                                    size={20}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setCreateBon(true);
                                      setEditData(row);
                                    }}
                                  />
                                  </div>
                                  <div className="col-5">
                                    <span
                                      onClick={() => {
                                        DeleteCampaign(row.idCampaign);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <Delete />
                                    </span>
                                  </div>
                                </div>
                                }
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Campaign;
